import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSaMinimal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 582,
	height: 186,
	viewBox: "0 0 582 186",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M153.87 1H29.87C13.4506 1 0.140015 14.3106 0.140015 30.73V154.73C0.140015 171.149 13.4506 184.46 29.87 184.46H153.87C170.289 184.46 183.6 171.149 183.6 154.73V30.73C183.6 14.3106 170.289 1 153.87 1Z",
			fill: "#DA0033"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.9 43.04H82.8301V84.19H100.9V43.04Z",
			fill: "#CCCCCC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M141.55 84.2001H100.9V102.27H141.55V84.2001Z",
			fill: "#CBCBCB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.83 84.2001H42.1801V102.27H82.83V142.42H100.9V102.27V84.2001H82.83Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M358.79 135.13C358.79 164.1 333.35 185.3 295.55 185.3C260.22 185.3 236.9 168.69 228.42 146.08L243.61 137.25C249.97 156.33 269.05 168.34 295.55 168.34C320.28 168.34 341.13 157.39 341.13 135.13C341.13 87.08 234.07 114.64 234.07 51.04C234.07 23.13 258.1 0.869995 294.13 0.869995C322.75 0.869995 344.65 14.65 354.19 36.2L339.35 44.68C331.93 26.31 313.56 17.83 294.13 17.83C271.16 17.83 251.73 29.84 251.73 51.04C251.73 98.38 358.79 70.47 358.79 135.13Z",
			fill: "#DA0033"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M582 4.76001V181.42H563.98V141.49C549.14 167.99 521.94 185.3 488.02 185.3C437.85 185.3 396.51 145.37 396.51 93.08C396.51 40.79 437.85 0.869995 488.02 0.869995C521.94 0.869995 549.15 18.18 563.98 44.68V4.76001H582ZM563.98 93.08C563.98 51.04 531.48 17.82 489.43 17.82C447.38 17.82 414.52 51.03 414.52 93.08C414.52 135.13 447.38 168.34 489.43 168.34C531.48 168.34 563.98 135.13 563.98 93.08Z",
			fill: "black"
		})
	]
});
export default SvgLogoSaMinimal;
